import { Image } from '@petsmart-ui/sparky';
import './brand-card.scss';

export type BrandCardModel = {
    href: string;
    imageUrl: string;
    label: string;
    openInNewTab?: boolean;
};

type BrandCardProps = {
    card: BrandCardModel;
    onClick?: () => void;
};

export function BrandCard({ card, onClick }: BrandCardProps) {
    return (
        <a
            href={card.href}
            className="brand-card"
            rel={card.openInNewTab ? 'noopener noreferrer' : undefined}
            target={card.openInNewTab ? '_blank' : undefined}
            onClick={onClick}
        >
            <Image src={card.imageUrl} alt="" className="brand-card__image" loading="lazy" />
            <span className="sparky-u-is-vishidden">{card.label}</span>
        </a>
    );
}
